var $59d615bd839f58d3$exports = {};
$59d615bd839f58d3$exports = {
    "endTime": `P\xe4\xe4ttymisaika`,
    "startTime": `Alkamisaika`,
    "time": `Aika`
};


export {$59d615bd839f58d3$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
